import { useParams } from 'react-router-dom'
import { getRequest } from '../../../../services/base'
import { useContext, useEffect, useRef, useState } from 'react'
import { Collapse, Empty, Flex, Modal, Typography } from 'antd'
import Button from '../../../common/Button'
import {
  SalesCodeComplexityContext,
  SET_SHOW_HIDE_ERROR_LOGS,
} from '../context/context'
import { downloadErrorLogs, formatDateTime } from '../../../../utils/common'
import RecordsCount from '../../../common/RecordsCount'
import { useIntl } from 'react-intl'
import { NavContext } from '../../../../context/global_context'
import { notifyError } from '../../../../utils/notifications'

const SalesCodeErrorLogs = () => {
  const { vehicle } = useParams()
  const intl = useIntl()
  const [state, dispatch] = useContext(SalesCodeComplexityContext)
  const [, navDispatch] = useContext(NavContext)
  const [logs, setLogs] = useState([])
  const [totalLogs, setTotalLogs] = useState(5)
  // const scrollRef = useRef(null)

  useEffect(() => {
    if (state.showErrorPopup) {
      getSalesCodeErrorLogs(5)
    }
  }, [state.showErrorPopup])

  const getSalesCodeErrorLogs = async (limit = 5) => {
    let res = await getRequest(
      `/api/plugin/sales_code/sales_code_upload_logs/${vehicle}/?limit=${limit}`
    )
    if (res?.status === false) {
      notifyError(navDispatch, intl.formatMessage({ id: 'salesCodeComplexity.logsLoadError' }))
      return
    }
    setLogs(res.data || [])
    setTotalLogs(res.total || 0)
  }

  const collapseItems = logs.map((fileObj, fileIndex) => {
    const updatedAt = fileObj?.updated_at
    return Object.entries(fileObj.log || {})
      .filter(([, logObj]) => logObj?.error?.length > 0 || logObj?.success?.length > 0)
      .map(([fileName], logIndex) => {
        const logObj = fileObj.log[fileName]
        return {
          key: `log-${logIndex}-${fileObj.id}-${fileIndex}`,
        label: (
          <Flex justify="space-between">
            <span>{fileName || 'Log'}</span>
            <span>{formatDateTime(updatedAt)}</span>
          </Flex>
        ),
        children: (
          <Flex justify="flex-end" gap={16}>
            {logObj?.error?.length > 0 && (
              <Button
                type="link"
                className="link-button"
                onClick={() => downloadErrorLogs(logObj.error, 'error.txt')}
              >
                {intl.formatMessage({ id: 'salesCodeComplexity.downloadErrorLogs' })}
              </Button>
            )}
            {logObj?.success?.length > 0 && (
              <Button
                type="link"
                className="link-button"
                onClick={() => downloadErrorLogs(logObj.success, 'success.txt')}
              >
                {intl.formatMessage({ id: 'salesCodeComplexity.downloadSuccessLogs' })}
              </Button>
            )}
          </Flex>
        ),
      }
    })
  })

  /* useEffect(() => {
    if (state?.showErrorPopup && scrollRef.current && collapseItems) {
      scrollRef.current.scrollTop = 0;
    }
  }, [scrollRef.current, state?.showErrorPopup, collapseItems]) */

  return (
    <Modal
      title={intl.formatMessage({ id: 'salesCodeComplexity.uploadTitle' })}
      open={state?.showErrorPopup}
      onCancel={() => dispatch({ type: SET_SHOW_HIDE_ERROR_LOGS, data: false })}
      width="75%"
      centered={true}
      styles={{
        body: {
          maxHeight: '70vh',
          overflowY: 'hidden',
        },
      }}
      footer={null}
    >
      {logs?.length > 0 ? (
        <Flex vertical gap={16}>
          <div /* ref={scrollRef} */ className='custom-scroll' style={{height: '60vh', overflowY: 'auto'}}>
            <Collapse items={collapseItems.flat()} />
          </div>
          {totalLogs !== logs.length && (
            <Flex justify="flex-end">
              <Button
                type="link"
                className="link-button"
                onClick={() => getSalesCodeErrorLogs(logs.length + 5)}
              >
                {intl.formatMessage({ id: 'salesCodeComplexity.showMore' })}
              </Button>
            </Flex>
          )}
        </Flex>
      ) : (
        <Empty description={<RecordsCount count={0} />} />
      )}
    </Modal>
  )
}

export default SalesCodeErrorLogs
